/**
 * AppDynamics Browser RUM initialization for web
 * This file should be imported in your web entry point (index.web.js)
 * Configuration aligned with mobile app settings from index.js
 */

// Import the configuration for consistency across the application
import { APPDYNAMICS_CONFIG } from '../src/utils/Instrumentation';

// Initialize AppDynamics Browser RUM with aligned configuration
if (typeof window !== 'undefined' && window.ADRUM) {
  // Set up global error handler to automatically report unhandled errors
  window.addEventListener('error', function(event) {
    if (window.ADRUM && window.ADRUM.reportError) {
      const error = new Error(event.message);
      error.stack = `${event.filename}:${event.lineno}:${event.colno}`;
      window.ADRUM.reportError(error, 'ERROR');
    }
  });

  // Set up unhandled promise rejection handler
  window.addEventListener('unhandledrejection', function(event) {
    if (window.ADRUM && window.ADRUM.reportError) {
      const error = new Error(event.reason?.message || 'Unhandled Promise Rejection');
      error.stack = event.reason?.stack || '';
      window.ADRUM.reportError(error, 'ERROR');
    }
  });

  // Set application-specific page data - aligned with mobile configuration
  if (window.ADRUM.addPageData) {
    window.ADRUM.addPageData('application', 'Lighthouse-Web');
    window.ADRUM.addPageData('version', process.env.REACT_APP_VERSION || '1.0.0');
    window.ADRUM.addPageData('environment', process.env.NODE_ENV || 'development');
    window.ADRUM.addPageData('appKey', APPDYNAMICS_CONFIG.appKey);
    window.ADRUM.addPageData('collectorURL', APPDYNAMICS_CONFIG.collectorURL);
  }

  console.log('AppDynamics Browser RUM initialized for Lighthouse Web App with aligned configuration');
} else {
  console.warn('AppDynamics Browser RUM not available - make sure the script is loaded in index.html with correct configuration');
}

// Export a utility to check if AppDynamics is available
export const isAppDynamicsAvailable = () => {
  return typeof window !== 'undefined' && window.ADRUM && typeof window.ADRUM.reportError === 'function';
};

// Export initialization function that can be called after user login
export const initializeAppDynamicsUser = (userInfo) => {
  if (window.ADRUM && window.ADRUM.addUserData) {
    if (userInfo.userId) window.ADRUM.addUserData('userId', userInfo.userId);
    if (userInfo.email) window.ADRUM.addUserData('userEmail', userInfo.email);
    if (userInfo.name) window.ADRUM.addUserData('userName', userInfo.name);
    if (userInfo.role) window.ADRUM.addUserData('userRole', userInfo.role);
    if (userInfo.location) {
      window.ADRUM.addUserData('locationId', userInfo.location.id);
      window.ADRUM.addUserData('locationName', userInfo.location.name);
    }
  }
};

// Re-export the configuration for web consumers
export { APPDYNAMICS_CONFIG };
